import React from 'react';
import { useNotificationStore } from '../../stores/notificationStore';
import { X, CheckCircle, AlertCircle, Info, AlertTriangle } from 'lucide-react';
import { cn } from '../lib/cn';

const icons = {
  success: <CheckCircle size={20} className="text-green-500" />,
  error: <AlertCircle size={20} className="text-red-500" />,
  info: <Info size={20} className="text-blue-500" />,
  warning: <AlertTriangle size={20} className="text-yellow-500" />,
};

const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useNotificationStore();

  return (
    <div className="fixed top-4 right-4 z-[9999] flex flex-col gap-2 pointer-events-none">
      {toasts.map((n) => (
        <div
          key={n.id}
          className={cn(
            'pointer-events-auto flex items-start gap-3 bg-white rounded-xl shadow-lg border px-4 py-3 min-w-[300px] max-w-sm',
            n.type === 'success' && 'border-green-200',
            n.type === 'error' && 'border-red-200',
            n.type === 'info' && 'border-blue-200',
            n.type === 'warning' && 'border-yellow-200',
          )}
        >
          {icons[n.type]}
          <p className="flex-1 text-sm text-gray-800">{n.message}</p>
          <button onClick={() => removeToast(n.id)} className="text-gray-400 hover:text-gray-600">
            <X size={16} />
          </button>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
